import React from "react";
import { useSearchParams } from "react-router";
import { Calendar } from "../calendar/Calendar";
import { ConditionalMapsApiProvider } from "../common/ConditionalMapsApiProvider";
import { ChangePasswordModal } from "../header/changePassword/ChangePasswordModal";
import { UserProfileModal } from "../header/userProfile/UserProfileModal";
import { AddPatientModal } from "../header/userSettings/AddPatientModal";
import { AddUserModal } from "../header/userSettings/AddUserModal";
import { CareMapDialog } from "../careMap/CareMapDialog";
import OrganizationMediaBase from "../organizationMedia/OrganizationMediaBase";
import { SyncQueueListing } from "../syncQueue/SyncQueueListing";
import { MoreArea } from "../more/MoreArea";
import { MODAL_ROUTES, QUERY_ROUTES } from "../routes";

export const ModalManager = () => {
  const [query, setQuery] = useSearchParams();
  const modalField = query.get(QUERY_ROUTES.MODAL);

  function closeModal() {
    query.delete(QUERY_ROUTES.MODAL);
    // The params a modal was opened with are only meaningful while it is open;
    // leaving them behind would re-seed the next one from a stale deep link.
    query.delete(QUERY_ROUTES.ADDRESS);
    setQuery(query);
  }

  switch (modalField) {
    case MODAL_ROUTES.CHANGE_PASSWORD:
      return <ChangePasswordModal closeModal={closeModal} />;
    case MODAL_ROUTES.USER_PROFILE:
      return <UserProfileModal closeModal={closeModal} />;
    case MODAL_ROUTES.ADD_USER:
      return <AddUserModal closeModal={closeModal} />;
    case MODAL_ROUTES.ADD_PATIENT:
      return <AddPatientModal closeModal={closeModal} />;
    case MODAL_ROUTES.ORGANIZATION_MEDIA:
      return <OrganizationMediaBase closeModal={closeModal} />;
    case MODAL_ROUTES.CALENDAR:
      return <Calendar closeModal={closeModal} />;
    case MODAL_ROUTES.CARE_MAP:
      return (
        <ConditionalMapsApiProvider>
          <CareMapDialog closeModal={closeModal} />
        </ConditionalMapsApiProvider>
      );
    case MODAL_ROUTES.SYNC_QUEUE:
      return <SyncQueueListing closeModal={closeModal} />;
    case MODAL_ROUTES.MORE:
      return <MoreArea closeModal={closeModal} />;
    default:
      return null;
  }
};
